module.exports = __webpack_public_path__ + "media/configurations/SV_O-X-5e7109e7.png";